import React from 'react';

let data = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0,]

const TermsConditions = () => (
    <div className="body_container">

        <div className="cm_breadcumd">
            <p>Terms & Conditions</p>
        </div>

        <div className="projects_card_wrapper">

            {
                data.map((item, index) => (
                    <div key={index}>
                        <h5>What is Lorem Ipsum?</h5>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                    </div>
                ))
            }


        </div>
    </div>
)

export default TermsConditions;